import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import ClientIndividual from '../../AddClient/components/ClientIndividual';
import ClientCorporation from '../../AddClient/components/ClientCorporation';
import instance from '../../../request/http'
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    // width: '100%',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        // width: '100%',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
    },
    '& .clientInfoWapper': {
        backgroundColor: '#FAFAFA',
        padding: '7px'
    },
    '& .notesText': {
        width: '100%',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const INDIVIDUAL = "individual";
const CORPORATION = "corporation";
class Client extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            radioValue: this.initData(),
            users: []
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
    }
    render() {
        const { data, state } = this.props;
        const { radioValue, users } = this.state;
        const checkInfo = () => {
            if (radioValue === INDIVIDUAL) {
                return <ClientIndividual
                    ref={(child) => { this.clientIndividual = child }}
                    users={users}
                    state={state}
                    data={data}
                ></ClientIndividual>
            } else if (radioValue === CORPORATION) {
                return <ClientCorporation
                    ref={(child) => { this.clientCorporation = child }}
                    users={users}
                    state={state}
                    data={data}
                ></ClientCorporation>
            }
        }
        return (
            <Root>
                <div className="textWapper">
                    <div className="clientInfoWapper">
                        <div className="title">Client Info</div>
                        <RadioGroup
                            aria-label="Gender"
                            name="gender1"
                            row
                            value={radioValue}
                            onChange={this.handleRadio}
                        >
                            <FormControlLabel disabled={this.isDisabled()} value={INDIVIDUAL} control={<Radio color="primary" />} label="Individual" />
                            <FormControlLabel disabled={this.isDisabled()} value={CORPORATION} control={<Radio color="primary" />} label="Corporation" />
                        </RadioGroup>
                        {checkInfo()}
                    </div>
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.getAdminUser();
    }
    initData() {
        const { data } = this.props;
        if (!data) return INDIVIDUAL;
        if (data.individual) {
            return INDIVIDUAL;
        } else if (data.corporation) {
            return CORPORATION;
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }
    getData() {
        const { radioValue } = this.state;
        let data = "";
        if (radioValue === INDIVIDUAL) {
            data = this.clientIndividual.handleGetData();
        } else if (radioValue === CORPORATION) {
            data = this.clientCorporation.handleGetData();
        }
        const obj = {
            "type": radioValue,
            "data": data
        }
        return obj;
    }
    handleCancel() {
        this.props.handleCancel();
    }

    getAdminUser() {
        let params = {
            page_index: 1,
            page_size: 100
        }
        instance.get(BASE_URL + 'users', { params }).then((res) => {
            let users = res.data.data
            this.setState(() => ({
                users
            }));
        })
    }
}

export default Client;